// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
// 如果用了 vue-i18n，需要引入 i18n 实例
import i18n from '@/lang'  // 假设你的 i18n 配置在 src/lang/index.js

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentLang: 'zh'  // 根状态中存储当前语言
    },
    mutations: {
        // 新增：修改语言的 mutation
        SET_CURRENT_LANG(state, lang) {
        state.currentLang = lang  // 更新状态
        if (i18n) {
            i18n.locale = lang  // 同步更新 vue-i18n 实例的语言（如果使用）
        }
        localStorage.setItem('lang', lang)  // 持久化到本地存储
        }
    },
    actions: {
        // 新增：触发语言切换的 action（供导航组件调用）
        changeLang({ commit }, lang) {
        commit('SET_CURRENT_LANG', lang)  // 调用 mutation 修改状态
        }
    },
    getters: {
        getCurrentLang: state => state.currentLang  // 已有的 getter，确保存在
    }
})